import { RowCrudStatus } from "../../common/types";
import {
  EditionType,
  EditionTypeCreateMutationVariables,
  EditionTypeUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type EditionTypeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name_es: string;
  name_en: string;
  name_pt: string;
};

export type EditionTypeErrorsType = {
  name_es?: { message: string; fieldLabel: string };
  name_en?: { message: string; fieldLabel: string };
  name_pt?: { message: string; fieldLabel: string };
};

export function EditionTypeValuesInit(): EditionTypeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name_es: "",
    name_en: "",
    name_pt: "",
  };
}

export type EditionTypeType = EditionType | EditionTypeValuesType;

export function editionTypeDisplayId(
  source: Partial<EditionType>,
  _langStore: LangStore
) {
  return `${source[_langStore.fieldByLang("name") as keyof EditionTypeType]}`;
}

export function getEditionTypeValues(
  source: EditionTypeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EditionTypeValuesType {
  const entityValues = EditionTypeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : editionTypeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name_es = source.name_es;
  entityValues.name_en = source.name_en;
  entityValues.name_pt = source.name_pt;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getEditionTypeUpdateVariables(
  values: EditionTypeValuesType
): EditionTypeUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
  };
}

export function getEditionTypeCreateVariables(
  values: EditionTypeValuesType
): EditionTypeCreateMutationVariables {
  return {
    name_es: values.name_es,
    name_en: values.name_en,
    name_pt: values.name_pt,
  };
}
